export default {
  selectors: {
    activePage: '[aria-current="page"]',
  },
};
